import { render, staticRenderFns } from "./SessionList.vue?vue&type=template&id=12229b51&scoped=true&lang=pug&"
import script from "./SessionList.vue?vue&type=script&lang=js&"
export * from "./SessionList.vue?vue&type=script&lang=js&"
import style0 from "./SessionList.vue?vue&type=style&index=0&id=12229b51&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12229b51",
  null
  
)

export default component.exports